export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13503.8ee0a439.jpg";